import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';

import FormSpinner from 'app/components/FormSpinner';

export default function LoadingState({ containerMaxHeight }) {
  return (
    <Col md={8} className="bb-payment-methods-bigbuy-page">
      <FormSpinner
        title="controlpanel.payment_methods.title"
        showButtons
        containerMaxHeight={containerMaxHeight}
      />
    </Col>
  );
}

LoadingState.propTypes = {
  containerMaxHeight: PropTypes.number
};

LoadingState.defaultProps = {
  containerMaxHeight: undefined
};
